<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="box-title-container mb-1">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <ion-icon name="car-sport"></ion-icon>
          </div>
          <div>
            <p class="title">Transportation</p>
          </div>
        </div>
        <div class="input-container d-flex align-items-center gap-1" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
          <div class="">
            <label class="label">Currency</label>
          </div>
          <select class="input py-1 border-1" (change)="onCurrencyChange($event)">
            <option *ngFor="let item of currencyLov" [selected]="selectedCurrency === item.key" [value]="item.key">{{item.name}}</option>
          </select>
        </div>
      </div>
    </div>
    <form [formGroup]="transportationForm" *ngIf="transportationForm">
    <div class="form-container ion-padding-horizontal">
      <ng-container formArrayName="transportations">
        <ng-container *ngFor="let transport of transportations().controls; let transportIndex = index" [formGroupName]="transportIndex">
           <div class="row">
            <div class="col-3">
              <div class="input-container">
                <label for="" class="label">Transportation Type</label>
                <div>
                  <select class="input" formControlName="typeOfTransport">
                    <option *ngFor="let transport of transportationTypes" [value]="transport.key">{{transport.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-7">
              <div class="input-container">
                <label for="" class="label">Upload Image / Enter Free Text</label>
                <div>
                  <div class="d-flex mb-1 mt-2">
                    <div class="radio-container">
                      <input formControlName="selectedType" class="radio-btn" type="radio" value="Image" [attr.id]="'imageUpload'+transportIndex">
                      <label class="radio-label" [attr.for]="'imageUpload'+transportIndex">Upload</label>
                    </div>
                    <div class="radio-container">
                      <input formControlName="selectedType" class="radio-btn" type="radio" value="FreeText" [attr.id]="'freeTextField'+transportIndex">
                      <label class="radio-label" [attr.for]="'freeTextField'+transportIndex">Free Text</label>
                    </div>
                    <div class="radio-container" *ngIf="flightApiEnabled && (checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.FLIGHT]))">
                      <ion-button class="unfilled-blue-btn btn-sm btn-border-0" (click)="openSearchFlights(transport, transportIndex)"><ion-icon class="me-1" name="search-outline"></ion-icon> Search Flights</ion-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="d-flex justify-content-end align-items-start">
                <div class="">
                  <button type="button" class="add-more-btn" (click)="removeTransportation(transportIndex)" *ngIf="transportations() .length !== 1">x Remove</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Image upload -->
          <ng-container *ngIf="transport.get('selectedType')?.value === 'Image'">
            <div class="row">
              <div class="col-12">
                <div class="input-container">
                  <label class="label text-capitalize">{{transport.get('typeOfTransport')?.value}} Details*</label>
                  <div *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.FLIGHT])">
                    <div class="d-flex cars-type-container">
                      <input formControlName="typeOfFlight" type="radio" value="Domestic" [attr.id]="'domesticFlight'+transportIndex"  class="input-radio me-1">
                      <label class="me-3" [attr.for]="'domesticFlight'+transportIndex">Domestic</label>
                      <input formControlName="typeOfFlight" type="radio" value="International" [attr.id]="'internationalFlight'+transportIndex" class="input-radio me-1">
                      <label [attr.for]="'internationalFlight'+transportIndex">International</label>
                    </div>
                  </div>
                  <div class="file-upload-container" [ngClass]="{'image-uploaded-true': transport.get('imageDoc')?.value}">
                    <div class="image-upload-container">
                      <div class="image-output">
                        <img [src]="getImgUrl(transport.get('imageDoc')?.value)" class="img">
                      </div>
                      <div class="d-flex">
                        <label [attr.for]="'transportDetailsImage'+transportIndex" class="upload-label clickable-text"><span><ion-icon name="cloud-upload-outline" class="upload-icon"></ion-icon> <span class="ms-1" [innerHTML]="transport.get('imageDoc')?.value ? 'Reupload' : 'Upload'"></span></span></label>
                        <!-- <label *ngIf="transport.get('imageDoc')?.value"  class="ms-2 delete-label text-danger" (click)="deleteImage('imageDoc', i)">Delete Image</label> -->
                      </div>
                      
                      <input type="file" [attr.id]="'transportDetailsImage'+transportIndex" class="file-upload input d-none" (change)="onFileSelected($event, transportIndex)" accept="image/*">
                    </div>
                  </div>
                  <div *ngIf="transport.get('imageDoc')?.invalid && transport.get('imageDoc')?.touched" class="text-danger error-message">
                    Please select an image.
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          

          <!-- Free text fields -->
          <ng-container *ngIf="transport.get('selectedType')?.value === 'FreeText'">
            <div class="row">
            <div class="col-4">
              <div class="input-container">
                <label class="label">
                  Transportation Name*
                </label>
                <div [ngClass]="{ 'invalid-input': transport.get('transportationName')?.invalid && transport.get('transportationName')?.dirty}">
                <input type="text" class="input" formControlName="transportationName" placeholder="Enter Transportation Name" />
                </div>
              </div>
            </div>
              <div class="col-4">
                <div class="input-container">
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'flight'" class="label">Departure Airport* </label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'train'" class="label">Pick-up Station* </label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'bus'" class="label">Pick-up Bus Stop* </label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'car'" class="label">Pick-up Location* </label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'ferry'" class="label">Pick-up Port* </label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'cruise'" class="label">Pick-up Port* </label>
                  <div [ngClass]="{ 'invalid-input': transport.get('departure')?.invalid && transport.get('departure')?.touched }">
                    <app-locations-autocomplete formControlName="departure" [placesType]="placesType"></app-locations-autocomplete>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="input-container">
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'flight'" class="label">Arrival Airport*</label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'train'" class="label">Drop-off Station*</label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'bus'" class="label">Drop-off Bus Stop*</label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'car'" class="label">Drop-off Location*</label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'ferry'" class="label">Drop-off Port*</label>
                  <label *ngIf="transport.get('typeOfTransport')?.value === 'cruise'" class="label">Drop-off Port*</label>
                  <div [ngClass]="{ 'invalid-input': transport.get('arrival')?.invalid && transport.get('arrival')?.touched }">
                    <app-locations-autocomplete formControlName="arrival" [placesType]="placesType"></app-locations-autocomplete>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.FLIGHT, TRANSPORTATION_TYPES.TRAIN, TRANSPORTATION_TYPES.BUS, TRANSPORTATION_TYPES.FERRY, TRANSPORTATION_TYPES.CRUISE])">
                <div class="input-container">
                  <label class="label">Departure Date*</label>
                  <div [ngClass]="{ 'invalid-input': transport.get('departureDate')?.invalid && transport.get('departureDate')?.touched }">
                    <app-date-picker [minDate]="todayNow" formControlName="departureDate"></app-date-picker>
                  </div>
                </div>
              </div>

              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.FLIGHT, TRANSPORTATION_TYPES.TRAIN, TRANSPORTATION_TYPES.BUS, TRANSPORTATION_TYPES.FERRY, TRANSPORTATION_TYPES.CRUISE])">
                <div class="input-container">
                  <label class="label">Departure Time*</label>
                  <div [ngClass]="{ 'invalid-input': transport.get('departureTime')?.invalid && transport.get('departureTime')?.touched }">
                    <app-time-picker formControlName="departureTime"></app-time-picker>
                  </div>
                </div>
              </div>

              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.FLIGHT, TRANSPORTATION_TYPES.TRAIN, TRANSPORTATION_TYPES.BUS, TRANSPORTATION_TYPES.FERRY, TRANSPORTATION_TYPES.CRUISE])">
                <div class="input-container">
                  <label class="label">Arrival Date*</label>
                  <div [ngClass]="{ 'invalid-input': transport.get('arrivalDate')?.invalid && transport.get('arrivalDate')?.touched }">
                    <app-date-picker formControlName="arrivalDate" [minDate]="transport.get('departureDate')?.value"></app-date-picker>
                  </div>
                </div>
              </div>

              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.FLIGHT, TRANSPORTATION_TYPES.TRAIN, TRANSPORTATION_TYPES.BUS, TRANSPORTATION_TYPES.FERRY, TRANSPORTATION_TYPES.CRUISE])">
                <div class="input-container">
                  <label class="label">Arrival Time*</label>
                  <div [ngClass]="{ 'invalid-input': transport.get('arrivalTime')?.invalid && transport.get('arrivalTime')?.touched }">
                    <app-time-picker formControlName="arrivalTime"></app-time-picker>
                  </div>
                </div>
              </div>

              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.TRAIN])">
                <div class="input-container">
                  <label class="label">Class</label>
                  <div>
                    <app-dropdown-select formControlName="class" [dropdownValues]="trainClassValues"></app-dropdown-select>
                  </div>
                </div>
              </div>

              <!-- Fields for cars -->
              <div class="col-3" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.CAR])">
                <div class="input-container">
                  <label for class="label">Vendor Company name*</label>
                  <div [ngClass]="{ 'invalid-input': transport.get('vendorName')?.invalid && transport.get('vendorName')?.touched }">
                    <app-vehicle-auto-complete  
                    [locationvalue]="transport.get('departure')?.value"
                    formControlName="vendorName" (predictionSelected)="gettingPopulatedHotelvalues($event, transportIndex)" 
                    ></app-vehicle-auto-complete>
                  </div>
                </div>
              </div>

              <div class="col-3" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.CAR])">
                <div class="input-container">
                  <label class="label">Name</label>
                  <div>
                    <app-dropdown-select formControlName="name"></app-dropdown-select>
                  </div>
                </div>
              </div>
              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.CAR])">
                <div class="input-container">
                  <label class="label">Transfer Mode</label>
                  <div>
                    <app-dropdown-select [dropdownValues]="transferModeValues" formControlName="mode"></app-dropdown-select>
                  
                  </div>
                </div>
              </div>

              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.CAR])">
                <div class="input-container">
                  <label class="label">Type</label>
                  <div>
                    <app-dropdown-select [dropdownValues]="vehicleTypeValues" formControlName="typeOfCar"></app-dropdown-select>
                  
                  </div>
                </div>
              </div>

              <div class="col-2" *ngIf="checkTransportationTypeExists(transport ,[TRANSPORTATION_TYPES.CAR])">
                <div class="input-container">
                  <label class="label">Number Of Seats</label>
                  <div>
                  <app-increment-number-input [max]="100" formControlName="numberOfSeats"></app-increment-number-input>
                </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Fields for prices -->
          <div class="row">
            <div class="col-3" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
              <div class="input-container">
                <label class="label">Cost / adult({{noOfAdults}} Adults)* </label>
                <div [ngClass]="{ 'invalid-input': transport.get('costPerAdult')?.invalid && transport.get('costPerAdult')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" [invalidInput]="transport.get('costPerAdult')?.invalid && transport.get('costPerAdult')?.touched" formControlName="costPerAdult"></app-select-text-input>
                </div>
              </div>
            </div>
            <div class="col-3" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
              <div class="input-container">
                <label class="label">Cost / child({{childrenAboveTwo}} Children)* </label>
                <div [ngClass]="{ 'invalid-input': transport.get('costPerChild')?.invalid && transport.get('costPerChild')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" [invalidInput]="transport.get('costPerChild')?.invalid && transport.get('costPerChild')?.touched" formControlName="costPerChild"></app-select-text-input>
                </div>
              </div>
            </div>
            <div class="col-3" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
              <div class="input-container">
                <label class="label">Cost / Infant({{childrenBelowTwo}} Children)* </label>
                <div [ngClass]="{ 'invalid-input': transport.get('costPerInfant')?.invalid && transport.get('costPerInfant')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" [invalidInput]="transport.get('costPerInfant')?.invalid && transport.get('costPerInfant')?.touched" formControlName="costPerInfant"></app-select-text-input>
                </div>
              </div>
            </div>
            <div class="col-3" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
              <div class="input-container">
                <label class="label">Total cost* </label>
                <div [ngClass]="{ 'invalid-input': transport.get('totalCost')?.invalid && transport.get('totalCost')?.touched }">
                  <app-select-text-input [prefix]="selectedCurrency" [invalidInput]="transport.get('totalCost')?.invalid && transport.get('totalCost')?.touched" formControlName="totalCost" [readonly]="true"></app-select-text-input>
                </div>
              </div>
            </div>
          </div>

          <div class="dashed-line my-2"></div>
        </ng-container>
      </ng-container>
      
      <div class="row">
        <div class="col">
          <div class="d-flex justify-content-end align-items-end h-100">
            <button type="button" class="add-more-btn mb-1" (click)="addTransportation()">+ Transportation</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12" *ngIf="checkTransportationTypePresent(TRANSPORTATION_TYPES.FLIGHT)">
          <div class="input-container">
            <label for="" class="label">Flight Notes</label>
            <div>
              <app-text-formatting-input formControlName="flightSectionNote"></app-text-formatting-input>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="checkTransportationTypePresent(TRANSPORTATION_TYPES.TRAIN)">
          <div class="input-container">
            <label for="" class="label">Train Notes</label>
            <div>
              <app-text-formatting-input formControlName="trainSectionNote"></app-text-formatting-input>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="checkTransportationTypePresent(TRANSPORTATION_TYPES.BUS)">
          <div class="input-container">
            <label for="" class="label">Bus Notes</label>
            <div>
              <app-text-formatting-input formControlName="busSectionNote"></app-text-formatting-input>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="checkTransportationTypePresent(TRANSPORTATION_TYPES.CAR)">
          <div class="input-container">
            <label for="" class="label">Car Notes</label>
            <div>
              <app-text-formatting-input formControlName="carSectionNote"></app-text-formatting-input>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="checkTransportationTypePresent(TRANSPORTATION_TYPES.FERRY)">
          <div class="input-container">
            <label for="" class="label">Ferry Notes</label>
            <div>
              <app-text-formatting-input formControlName="ferrySectionNote"></app-text-formatting-input>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="checkTransportationTypePresent(TRANSPORTATION_TYPES.CRUISE)">
          <div class="input-container">
            <label for="" class="label">Cruise Notes</label>
            <div>
              <app-text-formatting-input formControlName="cruiseSectionNote"></app-text-formatting-input>
            </div>
          </div>
        </div>
      </div> 
    </div>
    </form>
  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>